import { Component, EventEmitter, Input, Output } from '@angular/core';
import { IDropdownMenuItem } from 'src/models/common.model';
import { EInvestmentDetailMenuAction } from 'src/models/products.model';

@Component({
  selector: 'liberro-dropdown-menu-list',
  standalone: false,
  templateUrl: './liberro-dropdown-menu-list.component.html',
})
export class LiberroDropdownMenuListComponent {
  @Input() public items: IDropdownMenuItem[] = [];
  @Output() public itemClick = new EventEmitter<EInvestmentDetailMenuAction>();

  public onItemClick(item: IDropdownMenuItem): void {
    if (item.disabled) {
      return;
    }

    this.itemClick.emit(item.key);
  }
}

